import toastNotification from "./toastNotification";

let comparison = {
  get url() {
    return this.el.component.dataset.url;
  },
  get count() {
    return this.items.length;
  },
  el: {
    component: document.querySelector('[data-component="programs-comparisons"]'),
    componentHeader: document.querySelector('[data-action="toggle-comparisons-panel"]'),
    counter: document.querySelector('[data-element="comparisons-counter"]'),
    comparisonBody: document.querySelector('[data-element="comparisons-container"]'),
    htmlBody: document.querySelector('body')
  },
  items: [],
  programs: {},
  sources: {},
  session: Math.random().toString(36).substring(2, 10)
};

function addProgramForComparisonHendler(el) {

  return function (e) {

    e.preventDefault();

    let itemID = e.currentTarget.dataset.id;
    const tooltipEl = e.currentTarget.nextElementSibling;

    // Add new program only if it is not already in array
    if (comparison.items.indexOf(itemID) === -1) {

      if (comparison.count == 3) {
        toastNotification('You have reached the limit for the amount of programs you can compare at once', 'error')
        return true;
      }

      comparison.items.push(itemID);
      e.currentTarget.classList.add('active');
      tooltipEl.dataset.tooltip = 'Remove this program from comparison';
      // Set the information of the sources for the selected program
      // comparison.sources[el.getAttribute('data-id')] = el.getAttribute('data-source');

    } else {
      comparison.items = comparison.items.filter((elementID) => elementID !== itemID);
      e.currentTarget.classList.remove('active');
      tooltipEl.dataset.tooltip = 'Compare this program';
    }


    comparison.el.counter.textContent = comparison.count;
    comparison.el.counter.setAttribute('data-count', comparison.count);

    if (comparison.count > 0) {
      comparison.el.component.classList.add('visible');
    } else {
      comparison.el.component.classList.remove('visible');
    }
  }

}

function addProgramForComparison() {
  document.querySelectorAll('[data-action="compare-programs"]').forEach((el) => {
    el.addEventListener('click', addProgramForComparisonHendler(el))
  });
}

function removeProgramFromComparisonHendler(element, url) {

  return function (e) {
    const index = comparison.items.indexOf(e.currentTarget.dataset.id);
    const listButton = document.querySelector(`[data-action="compare-programs"][data-id="${element.dataset.id}"]`);

    if (index != -1) {
      comparison.items.splice(index, 1);
    }

    if (listButton) {
      listButton.classList.remove('active');
    }

    comparison.el.counter.textContent = comparison.count;
    comparison.el.counter.setAttribute('data-count', comparison.count);

    if (comparison.count > 0) {
      getSelectedProgramsForComparison(url);
    } else {
      // Toggle the visibility of the sections
      comparison.el.componentHeader.classList.remove('active');
      comparison.el.component.classList.remove('active', 'visible');
      comparison.el.htmlBody.style.overflow = 'initial';
    }
  }
}

function removeProgramFromComparison(url) {
  document.querySelectorAll('[data-action="remove-compare-program"]').forEach(function (xBtn) {
    xBtn.addEventListener('click', removeProgramFromComparisonHendler(xBtn, url))
  })
}

function getSelectedProgramsForComparison(url) {

  let body = new FormData();
  body.append('items', comparison.items);
  body.append('session', comparison.session);
  body.append('sources', JSON.stringify(comparison.sources));

  fetch(url, {
    method: 'POST',
    mode: "cors",
    credentials: "same-origin",
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: body
  })
    .then(function (response) {
      /**
       * Set the loader active for future loading requests
       */
      // attributes.loader = true;

      /**
       * Verify that we have the loading and hide it when the request has finished
       */
      if (document.querySelector('.pageload')) {
        // fadeOut(document.querySelector('.pageload'), function() {
        document.querySelector('.pageload').style.display = 'none';
        // });
      }

      return response.text();
    })
    .then(function (result) {
      // Verify that we have the content that we need in the response
      if (typeof result !== 'undefined' && result !== null && result !== 'null' && result.trim() !== '') {

        // Append the response HTML to the component
        comparison.el.comparisonBody.innerHTML = result;

        removeProgramFromComparison(url)

        return true;
      }

      // Set an error message when the source did not return any results
      return comparison.el.comparisonBody.textContent = 'Sorry, the list is empty at the moment';
    })
    .catch(function (error) {
      console.warn(error);

      comparison.el.htmlBody.style.overflow = 'initial';

      // Set an error message when we were unable to load the information from the source
      if (typeof error !== 'undefined' && error !== null && error !== 'null') {
        return comparison.el.comparisonBody.innerHTML = error;
      } else {
        return comparison.el.comparisonBody.textContent = 'Sorry, we were unable to load the information from the source';
      }

    });

}


function openComparisonComponent() {

  if (!comparison.url || comparison.url.trim() === '') {
    return false
  }

  comparison.el.componentHeader.addEventListener('click', function (e) {
    const el = e.currentTarget;

    el.classList.toggle('active');
    comparison.el.component.classList.toggle('active');

    // When the element have active class we will trigger an AJAX request to load the information
    if (el.classList.contains('active')) {

      getSelectedProgramsForComparison(comparison.url);
      comparison.el.htmlBody.style.overflow = 'hidden';

    } else {
      comparison.el.htmlBody.style.overflow = 'initial';
    }
  })

}

export {
  openComparisonComponent as default,
  addProgramForComparison,
  removeProgramFromComparison
}